var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.5C5.27614 4.5 5.5 4.72386 5.5 5V8.25C5.5 8.52614 5.27614 8.75 5 8.75C4.72386 8.75 4.5 8.52614 4.5 8.25V5C4.5 4.72386 4.72386 4.5 5 4.5Z",
    fill: "#6A8991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5C7.5 4.72386 7.27614 4.5 7 4.5C6.72386 4.5 6.5 4.72386 6.5 5V8.25C6.5 8.52614 6.72386 8.75 7 8.75C7.27614 8.75 7.5 8.52614 7.5 8.25V5Z",
    fill: "#6A8991"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82225 0.5C4.63965 0.5 4.47157 0.599539 4.3838 0.759658L3.70389 2H1C0.723858 2 0.5 2.22386 0.5 2.5C0.5 2.77614 0.723858 3 1 3H1.75V11C1.75 11.2761 1.97386 11.5 2.25 11.5H9.75C10.0261 11.5 10.25 11.2761 10.25 11V3H11C11.2761 3 11.5 2.77614 11.5 2.5C11.5 2.22386 11.2761 2 11 2H8.29899L7.63475 0.763398C7.54762 0.601194 7.3784 0.5 7.19427 0.5H4.82225ZM7.16386 2L6.89528 1.5H5.11836L4.84428 2H7.16386ZM2.75 3V10.5H9.25V3H2.75Z",
    fill: "#6A8991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.53832a15125ad949972e0404db510a51.svg";
export { ForwardRef as ReactComponent };